import {Pipe, PipeTransform} from '@angular/core';
import {PropertyType} from '@aztrix/models';
import {
  CustomFieldValueLabelRepresentation,
  ProposalLanguageRepresentation,
  ProposalLanguageStepRepresentation,
  ProposalLanguageTextTemplateRepresentation,
  ProposalRepresentation,
  RequestedPropertyRepresentation,
  RequestedPropertyTypeDescriptionRepresentation,
} from '@aztrix/sdk';

import {getLatestLanguage, getPropertyTypeDescriptions} from '../../helpers/proposal-functions';
import {_orderIndex} from '../../helpers/subscribe-step-functions';

@Pipe({name: 'itemDirty'})
export class ItemDirtyPipe implements PipeTransform {
  transform(
    item:
      | ProposalLanguageStepRepresentation
      | RequestedPropertyRepresentation
      | RequestedPropertyTypeDescriptionRepresentation
      | ProposalLanguageTextTemplateRepresentation
      | undefined,
    proposal: ProposalRepresentation,
    language: ProposalLanguageRepresentation
  ): boolean {
    if (!proposal || !proposal.languages || !language) {
      return false;
    }
    const languageOther = <ProposalLanguageRepresentation>(
      getLatestLanguage(proposal, language.languageCode)
    );

    if (item && 'requestedPropertyId' in item) {
      const descriptions = <RequestedPropertyTypeDescriptionRepresentation[]>(
        getPropertyTypeDescriptions(item, language)
      );
      const descriptionsPending = <RequestedPropertyTypeDescriptionRepresentation[]>(
        getPropertyTypeDescriptions(item, languageOther)
      );

      if (item.requestedPropertyTypes?.[0]?.type !== PropertyType.CUSTOM) {
        if (
          descriptions[0]?.type === descriptionsPending[0]?.type &&
          descriptions[0]?.description === descriptionsPending[0]?.description
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          descriptions[0]?.type === descriptionsPending[0]?.type &&
          descriptions[0]?.description === descriptionsPending[0]?.description &&
          descriptions[0]?.customFieldDescription?.label ===
            descriptionsPending[0]?.customFieldDescription?.label &&
          this.equalValueLabels(
            descriptions[0]?.customFieldDescription?.valueLabels || [],
            descriptionsPending[0]?.customFieldDescription?.valueLabels || []
          )
        ) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      const pendingStep = <ProposalLanguageStepRepresentation>item;
      const currentStep = this.getLatestStep(
        <ProposalLanguageStepRepresentation>pendingStep,
        languageOther
      );

      if (
        pendingStep.title === currentStep?.title &&
        pendingStep.description === currentStep?.description
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  getLatestStep(
    step: ProposalLanguageStepRepresentation,
    language: ProposalLanguageRepresentation
  ) {
    return (language?.steps || []).find(
      (s) => _orderIndex(s, language.items) === _orderIndex(step, language.items)
    );
  }

  equalValueLabels(
    valueLabels: CustomFieldValueLabelRepresentation[],
    changedValueLabels: CustomFieldValueLabelRepresentation[]
  ): boolean {
    for (const valueLabel of valueLabels || []) {
      const label = changedValueLabels.find((lb) => lb.value === valueLabel.value);
      if (!label || !label.label) {
        return false;
      }

      if (valueLabel.label !== label.label) {
        return false;
      }
    }

    return true;
  }
}
